// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G7zdO","footer":"styles_footer__10VVb"};